import script from "./NotificationsSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsSettings.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsSettings.vue?vue&type=style&index=0&id=f46212c8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f46212c8"]])

export default __exports__